import { env } from '@/constants/env.ts';

export const getImage = (imageId: string) => {
  return fetch(`${env.API_URL}/images/${imageId}?size=spherical`);
};
